import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzureAiFoundry = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			fillRule: "evenodd",
			d: "M15.772.91c.659 0 1.243.51 1.453 1.228.21.72 1.437 5.167 1.437 5.167v8.836h-4.448l.09-15.23h1.468Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#b)",
			d: "M22.302 7.814a.553.553 0 0 0-.554-.554h-2.621a3.343 3.343 0 0 0-3.34 3.34v5.541h3.175a3.343 3.343 0 0 0 3.34-3.34V7.814Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#c)",
			fillRule: "evenodd",
			d: "M15.772.91a.908.908 0 0 0-.914.914l-.09 16.818a4.449 4.449 0 0 1-4.447 4.448H2.248a.552.552 0 0 1-.524-.734L8.194 3.89A4.453 4.453 0 0 1 12.387.91h3.4-.015Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "a",
				x1: 17.629,
				x2: 13.885,
				y1: 16.471,
				y2: 1.479,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#712575" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .09,
						stopColor: "#9A2884"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#BF2C92"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .27,
						stopColor: "#DA2E9C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .34,
						stopColor: "#EB30A2"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4,
						stopColor: "#F131A5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#EC30A3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .61,
						stopColor: "#DF2F9E"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#C92D96"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#AA2A8A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .95,
						stopColor: "#83267C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#712575"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "b",
				x1: 19.052,
				x2: 19.052,
				y1: 1.225,
				y2: 22.371,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#DA7ED0" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .08,
						stopColor: "#B17BD5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .19,
						stopColor: "#8778DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .3,
						stopColor: "#6276E1"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .41,
						stopColor: "#4574E5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .54,
						stopColor: "#2E72E8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .67,
						stopColor: "#1D71EB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .81,
						stopColor: "#1471EC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#1171ED"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "c",
				x1: 17.779,
				x2: 3.761,
				y1: 1.704,
				y2: 24.183,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#DA7ED0" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .05,
						stopColor: "#B77BD4"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .11,
						stopColor: "#9079DA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#6E77DF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .25,
						stopColor: "#5175E3"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .33,
						stopColor: "#3973E7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .42,
						stopColor: "#2772E9"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .54,
						stopColor: "#1A71EB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .68,
						stopColor: "#1371EC"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#1171ED"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAzureAiFoundry);
export { ForwardRef as ReactComponent };
